import { render, staticRenderFns } from "./input-calling-code-and-phone.vue?vue&type=template&id=2899e6cb"
import script from "./input-calling-code-and-phone.vue?vue&type=script&lang=js"
export * from "./input-calling-code-and-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports